import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-user-choise-prompt',
  templateUrl: './user-choise-prompt.component.html',
  styleUrls: ['./user-choise-prompt.component.scss']
})
export class UserChoisePromptComponent implements OnInit {
  @Input() confirmButton: { text: string; action: { type: string; value: boolean; data?: any } } | undefined;
  @Input() cancelButton: { text: string; action: { type: string; value: boolean; data?: any } } | undefined;
  @Input() disable: boolean = false;
  @Output() handleUserChoise = new EventEmitter<{ text: string; action: { type: string; value: boolean; data?: any }}>();

  constructor() {
  }

  ngOnInit() {
  }

  onButtonClicked(button?: { text: string; action: { type: string; value: boolean; data?: any }}) {
    this.handleUserChoise.emit(button);
  }
}